<template>
  <v-dialog v-model="dialog" max-width="800" persistent>
    <v-card>
      <v-card-title class="headline">Chỉnh sửa</v-card-title>

      <v-card-text class="pt-0">
        <v-container grid-list-xl class="pa-0">
          <v-layout row wrap>
            <v-flex xs4>
              <v-text-field
                v-model="companyId"
                label="CompanyId"
                readonly
                class="body-1"
              ></v-text-field>
            </v-flex>

            <v-flex xs8>
              <v-text-field
                v-model="companyName"
                label="Name"
                class="body-1"
              ></v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-text-field
                v-model="companyFullName"
                label="Full Name"
                class="body-1"
              ></v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-text-field
                v-model="companyPhone"
                label="Phone"
                class="body-1"
              ></v-text-field>
            </v-flex>

            <v-flex xs4>
              <v-text-field
                v-model="companyContactName"
                label="Contact Name"
                class="body-1"
              ></v-text-field>
            </v-flex>

            <v-flex xs4>
              <v-text-field
                v-model="companyContactPhone"
                label="Contact Phone"
                class="body-1"
              ></v-text-field>
            </v-flex>

            <v-flex xs4>
              <v-text-field
                v-model="companyContactEmail"
                label="Contact Email"
                class="body-1"
              ></v-text-field>
            </v-flex>

            <v-flex xs6>
              <v-textarea
                v-model="companyAddress"
                no-resize
                name="input-7-4"
                label="Address"
                class="body-1"
              ></v-textarea>
            </v-flex>

            <v-flex xs6>
              <v-textarea
                v-model="companyRemark"
                placeholder=" "
                no-resize
                name="input-7-4"
                label="Remark"
                class="body-1"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          flat="flat"
          :loading="loading"
          @click="updateDataCompany"
        >
          Lưu
        </v-btn>

        <v-btn color="grey darken-1" flat="flat" @click="dialog = false">
          Hủy
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    props: {
      description: {
        type: String,
        default: 'Bạn có muốn xóa?',
      },
    },

    data: () => ({
      dialog: false,
      companyId: null,
      companyLevelId: null,
      companyName: null,
      companyFullName: null,
      companyPhone: null,
      companyContactName: null,
      companyContactEmail: null,
      companyContactPhone: null,
      companyAddress: null,
      companyRemark: null,
      loading: false,
    }),

    methods: {
      ...mapActions(['UpdateCompany']),

      open(data) {
        console.log('open -> data', data);
        this.companyId = data.Id;
        this.companyLevelId = data.CompanyLevelId;
        this.companyName = data.Name;
        this.companyFullName = data.FullName;
        this.companyPhone = data.Phone;
        this.companyContactName = data.ContactName;
        this.companyContactEmail = data.ContactEmail;
        this.companyContactPhone = data.ContactPhone;
        this.companyAddress = data.Address;
        this.companyRemark = data.Remark;
        this.dialog = true;
      },

      close() {
        this.reset();
        this.dialog = false;
      },

      reset() {
        this.companyId = null;
        this.companyLevelId = null;
        this.companyName = null;
        this.companyPhone = null;
        this.companyFullName = null;
        this.companyContactName = null;
        this.companyContactEmail = null;
        this.companyContactPhone = null;
        this.companyAddress = null;
        this.companyRemark = null;
        this.loading = false;
      },

      async updateDataCompany() {
        let data = {
          Id: this.companyId,
          CompanyLevelId: this.companyLevelId,
          Name: this.companyName,
          FullName: this.companyFullName,
          Phone: this.companyPhone,
          Address: this.companyAddress,
          ContactName: this.companyContactName,
          ContactEmail: this.companyContactEmail,
          ContactPhone: this.companyContactPhone,
          Remark: this.companyRemark,
        };
        //console.log(data);
        this.loading = true;
        let res = await this.UpdateCompany(data).catch((_) => {
          return null;
        });

        this.loading = false;

        if (!res) {
          window.getApp.showMessage(
            'Có lỗi xảy ra. Vui lòng thử lại.',
            'error'
          );
          return;
        }

        this.$emit('success', true, data);
        this.close();
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/crm/DialogUpdateCompany.vue